
export default {
  share: {
    fullUrl: 'Full',
    shortUrl: 'Short',
    urlCopied: 'URL copied to clipboard.',
    clickToCopy: 'Click to copy the URL',
    share: 'Share (click to copy)',
    shareLink: 'Share link',
    short: 'Short URL',
    copyUrlInfo: 'You can also copy the link from your browser`s address bar.',
    urlShortened: 'Shortened URL',
    shorteningNotPossible: 'It was not possible to generate a short URL. Please use the full URL',
    embedCodeCopied: 'Embedding code copied',
    embed: 'Embedding (click to copy)',
    embedInstructions: 'Use this code to embed ORS map in your website'
  }
}
